import React from "react";
import { CpuIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
export function Hero() {
  return <header className="bg-white px-4 pb-14 pt-6 sm:px-6 sm:pt-10" data-id="element-153" data-mp="9k0f38zo2hq6">
      <div className="mx-auto max-w-5xl text-center" data-id="element-154" data-mp="4lqiqv27hb2z">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-155" data-mp="4n1j0kwg00pc">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-night text-white" data-id="element-156" data-mp="129qwbqwlhzqi">
            <CpuIcon className="h-5 w-5" aria-hidden="true" data-id="element-157" data-mp="xa4e131wttau" />
          </span>
          <span className="font-display text-lg font-extrabold text-ink" data-id="element-158" data-mp="sb1e1x0sed9q">
            CAN Bus Diagnostic Blueprint<sup className="text-xs" data-id="element-159" data-mp="ncq0bb7dfim8">™</sup>
          </span>
        </div>

        <h1 className="mt-7 font-display text-[36px] font-black leading-[1.05] text-ink sm:text-5xl lg:text-[64px]" data-id="element-160" data-mp="nekkuoeqd8ps">
          Stop Guessing.{" "}
          <span className="text-brand" data-id="element-161" data-mp="381e0l9runzsg">Start Following a Clear CAN Bus Diagnostic Path.</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-soft sm:text-xl" data-id="element-162" data-mp="3j9u06x1wdkkr">
          Organize your next CAN Bus investigation in{" "}
          <strong className="text-ink" data-id="element-163" data-mp="39al9cd2bwm2m">10 minutes or less</strong>—with a structured, step-by-step blueprint that
          helps you identify what to check, document your findings, and determine your next diagnostic move.
        </p>

        <p className="mt-3 text-sm text-ink-muted" data-id="element-164" data-mp="30h9blrt8e1mr">
          Created by automotive electronics specialist <strong className="text-ink" data-id="element-165" data-mp="359sxrd5zi536">Jason Mitchell</strong>.
        </p>

        <img src={images.mockup} alt="CAN Bus Diagnostic Blueprint: six volumes and five bonus toolkits" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-166" data-mp="2qkdboaheentt" />

        <p className="mx-auto mt-2 max-w-2xl text-[16px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-167" data-mp="2hjf81tavgibr">
          Get instant access to <strong className="text-ink" data-id="element-168" data-mp="2ll0ht5s40ghq">6 professional digital volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-169" data-mp="s2jn3wuh80ji">5 exclusive bonuses</strong>, and a complete collection of diagnostic
          workflows, decision trees, investigation checklists, and case documentation tools.
        </p>

        <div className="mt-7" data-id="element-170" data-mp="ibgor2sxlznx">
          <CtaButton id="hero-cta" label="Yes! I want the CAN Bus Diagnostic Blueprint" data-id="element-171" data-mp="ichxv1qe0c30" />
        </div>
        <p className="mt-4 text-sm text-ink-muted" data-id="element-172" data-mp="deyj80ps1xaj">
          Instant Download · One-Time Payment of <strong className="text-ink" data-id="element-173" data-mp="1b0dts484tzyq">$27</strong> · Lifetime Access ·
          7-Day Money-Back Guarantee
        </p>

        <Countdown data-id="element-174" data-mp="15zq5vrf79z8q" />

        <p className="mx-auto mt-8 max-w-2xl text-xs leading-relaxed text-ink-muted" data-id="element-175" data-mp="112g55fmd215l">
          The 10-minute goal refers to organizing the initial investigation and selecting a logical next step—not
          necessarily identifying or repairing every fault within 10 minutes. Actual diagnostic time depends on the
          vehicle, fault, available information, and test results.
        </p>
      </div>
    </header>;
}